var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2727_373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V45H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2727_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6836 3.95508L33.0469 1.31836H11.9531L9.31641 3.95508H4.04297V19.1247C4.04297 30.4868 11.575 40.5075 22.5 43.6289C33.425 40.5075 40.957 30.4868 40.957 19.1247V3.95508H35.6836Z",
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 33.0469C18.1314 33.0469 14.5898 29.5054 14.5898 25.1367V17.2266H30.4102V25.1367C30.4102 29.5054 26.8687 33.0469 22.5 33.0469Z",
    fill: "url(#paint0_linear_2727_373)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 17.2266V11.8652C17.2266 8.9528 19.5876 6.5918 22.5 6.5918C25.4124 6.5918 27.7734 8.9528 27.7734 11.8652V17.2266",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.1816V29.0918",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_373",
    x1: 14.5,
    y1: 17.5,
    x2: 30,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/Privacy.7faa28ceeb0fa31bc7fa7e0d692951bd.svg";
export { ForwardRef as ReactComponent };